//@ts-ignore
import { createEffect, createSignal, onMount, createMemo, Index } from "solid-js";
import { View, Text, hexColor, Show } from "@lightningtv/solid";
import { useNavigate, useParams } from "@solidjs/router";
import styles from "../../styles";
import { setGlobalBackground } from "../../../state";
import { Row } from "@lightningtv/solid-ui";
import { createInfiniteScroll } from "../../components/pagination";
import { LazyUp } from "@lightningtv/solid/primitives";
import searchSeries from "../../api/providers/searchSeries";
import LoadingIndicator from "../loading/loading";
import Header from "../../components/Header";
import { fontFamily, isRTL, t } from "../../translations/configuration";
import { IconButton } from "../../components/playlistComponents/TopRightHeaders";
import KbPanel from "../../components/KbPanel";

const SearchSeriesPage = () => {
  const [inputValue, setInputValue] = createSignal("");
  const [isLoading, setIsLoading] = createSignal(true);
  const [hasError, setHasError] = createSignal(false);
  const [focusedItem, setFocusedItem] = createSignal<any>(null);
  const [failedImages, setFailedImages] = createSignal<Set<string>>(new Set());

  let kbPanelRef: { setFocus: () => void } | undefined;
  let settingsRef: any, headerRef: any;

  const params = useParams();
  const navigate = useNavigate();

  const [data2, setData2] = createSignal(null);
  const [data, setData] = createSignal(null);

  const providerCategory = createMemo(() => {
    return createInfiniteScroll(
      //@ts-ignore
      searchSeries(params.filter || "all"),
    );
  });

  const handleImageError = (id: string) => {
    setFailedImages(prev => new Set([...prev, id]));
  };

  createEffect(() => {
    try {
      setIsLoading(true);
      setHasError(false);
      const kevi: any = providerCategory().pages();
      if (providerCategory().pages()) {
        //@ts-ignore
        setData(kevi);
        setIsLoading(false);
        setHasError(false);
        setTimeout(() => kbPanelRef?.setFocus(), 100);
      }
    } catch (error) {
      console.error("Error loading series data:", error);
      setIsLoading(false);
      setHasError(true);
    }
  });

  onMount(() => {
    setGlobalBackground("#0A1C34");
    setIsLoading(true);
    const storedData = localStorage.getItem("moviesData");
    if (storedData) setData2(JSON.parse(storedData));
  });

  createEffect(() => { localStorage.setItem("searchInput", inputValue()); });

  onMount(() => {
    const storedInput = localStorage.getItem("searchInput");
    if (storedInput) setInputValue(storedInput);
  });

  const [displayedItems, setDisplayedItems] = createSignal([]);

  // ── RTL right-to-left row ─────────────────────────────────────────────────
  const RTL_VISIBLE = 6;
  const RTL_STEP = 182; // 166 + 16
  const RTL_ITEM_W = 166;
  const RTL_PANEL_W = 1200;

  const [rtlViewStart, setRtlViewStart] = createSignal(0);
  const [rtlFocusIdx, setRtlFocusIdx] = createSignal(0);
  const rtlRefs: any[] = Array(RTL_VISIBLE).fill(null);

  createEffect(() => { displayedItems(); setRtlViewStart(0); setRtlFocusIdx(0); });

  const rtlWindowItems = () => displayedItems().slice(rtlViewStart(), rtlViewStart() + RTL_VISIBLE);
  const rtlX = (rel: number) => RTL_PANEL_W - RTL_ITEM_W - rel * RTL_STEP;

  const rtlMoveLeft = () => {
    if (isLoading() || hasError()) return;
    if (rtlFocusIdx() < RTL_VISIBLE - 1) {
      const nf = rtlFocusIdx() + 1; setRtlFocusIdx(nf);
      setTimeout(() => rtlRefs[nf]?.setFocus(), 0);
    } else if (rtlViewStart() + RTL_VISIBLE < displayedItems().length) {
      setRtlViewStart(s => s + 1);
      setTimeout(() => rtlRefs[RTL_VISIBLE - 1]?.setFocus(), 0);
    }
  };

  const rtlMoveRight = () => {
    if (isLoading() || hasError()) return;
    if (rtlFocusIdx() > 0) {
      const nf = rtlFocusIdx() - 1; setRtlFocusIdx(nf);
      setTimeout(() => rtlRefs[nf]?.setFocus(), 0);
    } else if (rtlViewStart() > 0) {
      setRtlViewStart(s => s - 1);
      setTimeout(() => rtlRefs[0]?.setFocus(), 0);
    } else {
      kbPanelRef?.setFocus();
    }
  };

  const filterData = () => {
    if (!inputValue()) return providerCategory().pages();
    return providerCategory().pages()
      .filter((item: any) => item.title.toLowerCase().includes(inputValue().toLowerCase()));
  };

  createEffect(() => {
    const filtered: any = filterData();
    setDisplayedItems([]);
    setTimeout(() => setDisplayedItems(filtered), 0);
  });

  let viewRef: any;
  const titleSignal = createSignal("");
  const keyEvent = createSignal("");
  const [resetLazyUp, setResetLazyUp] = createSignal(false);

  createEffect(() => {
    titleSignal[0]();
    setResetLazyUp(false);
    setTimeout(() => setResetLazyUp(true), 0);
  });

  createEffect(() => {
    if (data()) console.log('data length ', data().length);
  }, [data()]);

  const handleKeypadInteraction = (callback: () => void) => {
    if (!isLoading() && !hasError()) callback();
  };

  return (
    <View color={hexColor("#0d0f14")} width={1920} height={1080}>
      <View
        width={1920}
        onEscape={() => { if (!isLoading()) navigate(-1); }}
        height={1080}
        positionAbsolute={0}
      >

        <Header screen={t("search")} ref={(el) => headerRef = el}
          onDown={() => handleKeypadInteraction(() => kbPanelRef?.setFocus())}
          onLeft={() => isRTL() ? settingsRef?.setFocus() : null}
          onRight={() => isRTL() ? null : settingsRef?.setFocus()} />

        {/* ── Settings button top-right ── */}
        <View x={isRTL() ? 50 : 1700} y={50}>
          <IconButton
            onRef={(el) => { settingsRef = el; }}
            x={100} y={0}
            src="https://i.ibb.co/Jjp8bmn4/setting.png"
            onEnter={() => handleKeypadInteraction(() => navigate("/userInfo"))}
            onLeft={() => isRTL() ? null : headerRef?.setFocus()}
            onRight={() => isRTL() ? headerRef?.setFocus() : null}
            onDown={() => handleKeypadInteraction(() => kbPanelRef?.setFocus())}
          />
        </View>

        {/* ── LEFT PANEL ── */}
        <View
          x={isRTL() ? 1350 : 70} y={200}
          width={500} height={760}
          borderRadius={30}
          color={hexColor("#12151c")}
        >
          {/* "Search" label */}
          <Text x={30} y={60} style={{ fontSize: 30, color: hexColor("#f0f6fc"), fontWeight: "bold", fontFamily: fontFamily() }}>
            {t("search")}
          </Text>

          <View
            x={440} y={60}
            width={40} height={40}
            borderRadius={10}
            color={hexColor("#202329")}
          >
            <Text x={13} y={8} style={{ fontSize: 25, color: hexColor("#f0f6fc"), fontWeight: "bold", fontFamily: fontFamily() }}>
              x
            </Text>
          </View>

          {/* Search input box */}
          <View
            x={30} y={120}
            width={450} height={70}
            borderRadius={10}
            color={hexColor("#202329")}
            style={{ border: { width: 1, color: hexColor("#2d3748") } }}
          >
            <View x={20} y={23} width={24} height={24} src="https://i.ibb.co/nNhBcw8M/search.png" color={hexColor("#4b5563")} />
            <Text
              x={60} y={27}
              style={{ fontSize: 24, color: hexColor(inputValue() ? "#f0f6fc" : "#ffffff") }}
            >
              {inputValue() || t("searchSeries") + " ..."}
            </Text>
          </View>

          <View x={30} y={200}>
            <KbPanel
              kbRef={(r) => { kbPanelRef = r; }}
              value={inputValue}
              fieldLabel={() => t("search")}
              hidePreview={true}
              onChar={(c) => setInputValue(v => v + c)}
              onBackspace={() => setInputValue(v => v.slice(0, -1))}
              onDone={() => handleKeypadInteraction(() => isRTL() ? rtlRefs[0]?.setFocus() : viewRef?.setFocus())}
            />
          </View>
        </View>

        {/* ── RIGHT PANEL ── */}
        <View x={isRTL() ? 70 : 650} y={270} width={1200} height={700}>

          {/* Title + count badge */}
          <View x={0} y={0} style={{ flexDirection: "row" }} gap={16}>
            <Text style={{ fontSize: 36, color: hexColor("#f0f6fc"), fontWeight: "bold", fontFamily: fontFamily() }}>
              {t("series")}
            </Text>
            <Show when={data() && displayedItems().length > 0}>
              <View
                x={150} y={6}
                width={125} height={28}
                borderRadius={8}
                color={hexColor("#12151c")}
              >
                <Text x={10} y={6} style={{ fontSize: 18, color: hexColor("#8b949e"), fontWeight: "bold" }}>
                  {String(displayedItems().length)} SERIES
                </Text>
              </View>
            </Show>
          </View>

          {/* Poster row */}
          <Show when={!isLoading() && !hasError()}>

            {/* LTR */}
            <Show when={!isRTL()}>
              <View y={70} clipping>
                <Show when={resetLazyUp()}>
                  {/* @ts-ignore */}
                  <LazyUp
                    component={Row}
                    onLeft={() => handleKeypadInteraction(() => kbPanelRef?.setFocus())}
                    ref={viewRef}
                    scroll="always"
                    direction={"row" as any}
                    upCount={8}
                    each={displayedItems()}
                    gap={16}
                  >
                    {(item: any) => (
                      <View
                        width={166} height={250}
                        borderRadius={12}
                        style={{
                          border: { width: 0, color: hexColor("#2563eb") },
                          focus: { border: { width: 3, color: hexColor("#2563eb") } },
                        }}
                        onUp={() => settingsRef.setFocus()}
                        onFocus={() => setFocusedItem(item())}
                        onEnter={() => handleKeypadInteraction(() =>
                          navigate(`/serieDetails/series/${item().stream_id}/${item().category_id}`)
                        )}
                      >
                        <View x={2} y={2} width={162} height={246} borderRadius={12}
                          src={failedImages().has(String(item().stream_id))
                            ? "https://assets.orbixplay.com/no_movie_image_placeholder.png"
                            : (item().image_stream || item().cover)?.replace?.('http://', 'https://')
                            || "https://assets.orbixplay.com/no_movie_image_placeholder.png"}
                          onError={() => handleImageError(String(item().stream_id))}
                        />
                      </View>
                    )}
                  </LazyUp>
                </Show>
              </View>
            </Show>

            {/* RTL */}
            <Show when={isRTL()}>
              <View y={70} width={1200} height={270} clipping>
                <Index each={rtlWindowItems() as any[]}>
                  {(item: any, relIdx) => (
                    <View
                      ref={(el: any) => { rtlRefs[relIdx] = el; }}
                      x={rtlX(relIdx)} y={0}
                      width={166} height={250}
                      borderRadius={12}
                      style={{
                        border: { width: 0, color: hexColor("#2563eb") },
                        focus: { border: { width: 3, color: hexColor("#2563eb") } },
                      }}
                      onLeft={rtlMoveLeft}
                      onRight={rtlMoveRight}
                      onUp={() => settingsRef?.setFocus()}
                      onFocus={() => { setFocusedItem(item()); setRtlFocusIdx(relIdx); }}
                      onEnter={() => handleKeypadInteraction(() =>
                        navigate(`/serieDetails/series/${item().stream_id}/${item().category_id}`)
                      )}
                    >
                      <View x={2} y={2} width={162} height={246} borderRadius={12}
                        src={failedImages().has(String(item().stream_id))
                          ? "https://assets.orbixplay.com/no_movie_image_placeholder.png"
                          : (item().image_stream || item().cover)?.replace?.('http://', 'https://')
                          || "https://assets.orbixplay.com/no_movie_image_placeholder.png"}
                        onError={() => handleImageError(String(item().stream_id))}
                      />
                    </View>
                  )}
                </Index>
              </View>
            </Show>

            <Show when={displayedItems().length === 0}>
              <Text x={200} y={170} fontSize={30} style={{ color: hexColor("#7d7e82"), fontFamily: fontFamily() }}>
                {t("noSeriesFound")}
              </Text>
            </Show>

            {/* ── Detail card — only shown when an item is focused ── */}
            <Show when={focusedItem()}>
              <View
                x={0} y={350}
                width={1200} height={160}
                borderRadius={16}
                color={hexColor("#15171b")}
              //style={{ border: { width: 2, color: hexColor("#1e2a3a") } }}
              >
                <View x={24} y={20}>
                  {/* Title */}
                  <Text style={{ fontSize: 28, color: hexColor("#f0f6fc"), fontWeight: "bold", fontFamily: fontFamily() }}>
                    {focusedItem()?.name || focusedItem()?.title}
                  </Text>

                  {/* Meta row: year • duration • rating */}
                  <View x={0} y={44} style={{ flexDirection: "row" }} gap={16}>
                    <Show when={focusedItem()?.releaseDate}>
                      <Text style={{ fontSize: 22, color: hexColor("#8b949e") }}>
                        {focusedItem()?.releaseDate?.substring(0, 4)}
                      </Text>
                      <Text style={{ fontSize: 22, color: hexColor("#4b5563") }}>•</Text>
                    </Show>
                    <Show when={focusedItem()?.episode_run_time && focusedItem()?.episode_run_time !== "0"}>
                      <Text style={{ fontSize: 22, color: hexColor("#8b949e") }}>
                        {focusedItem()?.episode_run_time}
                      </Text>
                      <Text style={{ fontSize: 22, color: hexColor("#4b5563") }}>•</Text>
                    </Show>
                    <View width={90} height={30} borderRadius={6} color={hexColor("#2d2a1a")}>
                      <View x={8} y={5} width={20} height={20} src="https://i.ibb.co/4gK6MnK/star-1.png" />
                      <Text x={34} y={8} style={{ fontSize: 20, color: hexColor("#f5c518"), fontWeight: "bold" }}>
                        {focusedItem()?.stars?.toFixed(1)}
                      </Text>
                    </View>
                  </View>

                  {/* Genre + director */}
                  <View x={0} y={82} style={{ flexDirection: "row" }} gap={12}>
                    <Show when={focusedItem()?.genre}>
                      <Text style={{ fontSize: 20, color: hexColor("#6b7280") }}>
                        {focusedItem()?.genre}
                      </Text>
                    </Show>
                    <Show when={focusedItem()?.director}>
                      <Text style={{ fontSize: 20, color: hexColor("#4b5563") }}>·</Text>
                      <Text style={{ fontSize: 20, color: hexColor("#6b7280") }}>
                        {focusedItem()?.director}
                      </Text>
                    </Show>
                  </View>
                </View>

                {/* Press OK hint */}
                <View x={24} y={116} style={{ flexDirection: "row" }} gap={10}>
                  <View x={0} y={0} width={32} height={32} borderRadius={16} color={hexColor("#2563eb")}>
                    <View x={2} y={2} width={30} height={30} src="https://i.ibb.co/WNPhwwTN/Arrow-Forward.png" />
                  </View>
                  <Text x={40} y={10} style={{ fontSize: 18, color: hexColor("#8b949e") }}>{t("pressOkToPlay")}</Text>
                </View>
              </View>
            </Show>
          </Show>
        </View>

        {/* Loading overlay */}
        <Show when={isLoading()}>
          <View width={1920} height={1080} color={hexColor("#000000")} alpha={0.7} positionAbsolute={0}>
            <View x={960} y={500}>
              <LoadingIndicator isCategoriesIndicator={false} />
            </View>
          </View>
        </Show>

        {/* Error overlay */}
        <Show when={hasError()}>
          <View width={1920} height={1080} color={hexColor("#000000")} alpha={0.8} positionAbsolute={0}>
            <View x={760} y={400}>
              <Text fontSize={42} color={hexColor("#ffffff")} style={{ fontFamily: fontFamily() }}>
                {t("thereIsProblem")}
              </Text>
              <Text x={50} y={60} fontSize={28} color={hexColor("#8b949e")} style={{ fontFamily: fontFamily() }}>
                {t("tryAgainLater")}
              </Text>
            </View>
          </View>
        </Show>

      </View >
    </View >
  );
};

export default SearchSeriesPage;